import { KeyValue } from "@/main/models/common";
import { ValuatorFilterRequest } from "@/main/models/request/valuatorRequest";

export enum ValuatorTypes {
	GET_VALUATORS = "@valuator/GET_VALUATORS",
	SAVE_VALUATORS = "@valuator/SAVE_VALUATORS",
	RESET_REDUCER_VALUATORS = "@valuator/RESET_REDUCER_VALUATORS",
}

export interface ValuatorState {
	readonly valuators: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
}

export interface GetValuators {
	type: typeof ValuatorTypes.GET_VALUATORS;
	payload: {
		request: ValuatorFilterRequest;
	};
}

export interface SaveValuators {
	type: typeof ValuatorTypes.SAVE_VALUATORS;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerValuators {
	type: typeof ValuatorTypes.RESET_REDUCER_VALUATORS;
}

export type ValuatorActionTypes = GetValuators | SaveValuators | ResetReducerValuators;
